import { render, staticRenderFns } from "./MatchScreenshots.vue?vue&type=template&id=bce2c4f8&scoped=true&"
import script from "./MatchScreenshots.vue?vue&type=script&lang=js&"
export * from "./MatchScreenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce2c4f8",
  null
  
)

export default component.exports